/**
 * /crm — CRM overview landing (tile launcher).
 *
 * Mirrors the ERP overview (`/erp`): a grid of navigation tiles so a
 * user opening the CRM lands on a clear launcher instead of being
 * dropped straight into a list. Tiles are role-gated (manager+ sees
 * Team / Reports / Settings).
 */

import { createFileRoute } from "@tanstack/react-router";
import { Briefcase } from "lucide-react";

import { TileGrid, crmTiles } from "../components/AppTiles";
import { useAuthStore } from "../lib/auth";

export const Route = createFileRoute("/_app/crm")({
  component: CrmOverviewPage,
});

function CrmOverviewPage() {
  const user = useAuthStore((s) => s.user);
  const tiles = crmTiles(user?.role ?? "sales");

  return (
    <div className="page-shell space-y-5 p-4 sm:p-6">
      <header className="space-y-1">
        <h1 className="flex items-center gap-2 text-2xl font-semibold tracking-tight">
          <Briefcase className="size-5 opacity-70" aria-hidden />
          CRM Overview
        </h1>
        <p className="text-sm opacity-60">
          Contacts, accounts, deals, and follow-ups. Use the launcher to switch to ERP or open Home
          for both.
        </p>
      </header>

      <TileGrid tiles={tiles} />
    </div>
  );
}
